import { render, staticRenderFns } from "./ModalSkuFreebie.vue?vue&type=template&id=0b5161d5&scoped=true&"
import script from "./ModalSkuFreebie.vue?vue&type=script&lang=js&"
export * from "./ModalSkuFreebie.vue?vue&type=script&lang=js&"
import style0 from "./ModalSkuFreebie.vue?vue&type=style&index=0&id=0b5161d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5161d5",
  null
  
)

export default component.exports